








import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { historyStage } from '@/api/project';
import { phaseMap } from '@/utils/project';

interface selectItem {
  name: String;
  key: String;
  phase: Number;
  roundName: String;
  round: Number;
}
@Component({
  components: {}
})
class StageSelect extends Vue {
  @Prop()
  companyId;

  @Prop()
  type; // 0:可选所有阶段 1:可选自己有权限的阶段

  @Prop()
  value; // {round: 1, phase: 0}

  @Prop()
  selectDisabled;

  @Prop()
  reFresh;

  selectionList: selectItem[] = [];
  selectedKey = '';

  created() {
    this.initSelection();
  }
  @Watch('value', { immediate: true })
  valueChange(value) {
    if (value && (value.round || value.round === 0) && (value.phase || value.phase === 0)) {
      this.selectedKey = `${value.round}${value.phase}`;
    }
  }

  @Watch('reFresh')
  reFreshChange(value) {
    this.selectedKey = '';
  }

  async initSelection() {
    let { type } = this;
    let res = await historyStage({
      type,
      id: this.companyId
    });
    let stageList = res.data || [];
    this.selectionList = stageList.map(cur => {
      cur.name = `${cur.roundName}轮${phaseMap[cur.phase]}`;
      cur.key = `${cur.round}${cur.phase}`;
      return cur;
    });
  }
  handleChange(key) {
    this.selectedKey = key;
    let selected = this.selectionList.find(_ => _.key === key) as selectItem;
    this.$emit('input', {
      round: selected.round,
      phase: selected.phase
    });
  }
}

export default StageSelect;
